/*global __CLIENT__*/
import React, { Component } from 'react';

import '../styles/Loading.css';

export default class Loading extends Component {
  render() {
    const { loadingMessage } = this.props;
    const wrapperStyle = {
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
      flex: '1 0 100%',
      flexDirection: 'column',
    };

    return (
      <div style={wrapperStyle}>
        <ul className="loader-list">
          <li>
            <div className="loader-5 loading-center"><span></span></div>
          </li>
          {loadingMessage && <li>
            <div style={{ textAlign: 'center', marginTop: 10 }}>
              <b>{loadingMessage}</b>
            </div>
          </li>}
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Loading.js